import {Box, Button, CircularProgress, Grid, Typography} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import { useHistory, useParams } from "react-router-dom";
import {GiftCardSubCategoryApi} from "../../../services/api/giftCard";
import Product from "./components/product";
import {fetchGiftCard} from "../../../redux/giftCard/actions";
import {useDispatch} from "react-redux";

const GiftCardItemsView = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const param = useParams<any>();
    const [brands, setBrands] = useState([]);
    const [loading, setLoading] = useState(true);

    const api = async () => {
        setLoading(true)
        const res = await GiftCardSubCategoryApi({group_id:param.gid});
        res&& setLoading(false);
        setBrands(res?.data);
    }

    const giftCardPaymentHandler = (item: object) => {
        dispatch(fetchGiftCard(item))
        history.push("/payment/gift");
    }


    useEffect(() => {
        api();
    }, []);

    return(
        <>
            {/* @ts-ignore */}
            <Box style={{ width: "15%", marginTop: "40px", marginLeft: "8%" }}>
                <Button
                    variant="contained"
                    className="w-100 text-white typeBackground round-btn"
                    size="large"
                    onClick={() => {history.push("/");}}
                >
                    بازگشت
                </Button>
            </Box>
            <Grid container justifyContent="center" style={{marginTop: "40px"}}>
                <Grid item md={10}>
                    {/* @ts-ignore */}
                    <Box className="dir p-res Box mainBox customBox">
                        <Grid container>
                            <Grid item xs={12}>
                                {/* @ts-ignore */}
                                <Grid container className="mt-3" spacing={1}>
                                    {loading ? (
                                            <>
                                                {/* @ts-ignore */}
                                                <Box sx={{ margin: "0px auto" }}>
                                                    <div style={{ textAlign: "center" }}>
                                                        <CircularProgress />
                                                    </div>
                                                    <Typography>در حال دریافت اطلاعات ...</Typography>
                                                </Box>
                                            </>
                                        )
                                        : (
                                            brands?.map((item: any) => (
                                                <Product
                                                    key={item["groupid"]}
                                                    item={item}
                                                    giftCardPaymentHandler={giftCardPaymentHandler}
                                                />
                                            ))
                                        )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </>
    );
}

export default GiftCardItemsView;